// The on-screen keyboard (touch Chromebooks in tablet mode, phones) shrinks the visible area and
// can cover the field being typed in. When the viewport shrinks, scroll the focused field back into
// view. Listens to visualViewport where it exists, which also covers keyboards that only shrink the
// visual viewport.
const typingInto = (el) => !!el && (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) || el.isContentEditable);

export function keepFocusVisible(win = window) {
	const vv = win.visualViewport;
	let raf = 0;
	const fix = () => {
		raf = 0;
		const el = win.document.activeElement;
		if (!typingInto(el)) return;
		const r = el.getBoundingClientRect();
		const top = vv ? vv.offsetTop : 0, h = vv ? vv.height : win.innerHeight;
		if (r.top >= top && r.bottom <= top + h) return;
		try { el.scrollIntoView({ block: r.height > h ? "start" : "nearest", inline: "nearest" }); } catch (e) { el.scrollIntoView(false); }
	};
	const later = () => { if (!raf) raf = requestAnimationFrame(fix); };
	if (vv) vv.addEventListener("resize", later);
	win.addEventListener("resize", later);
}
